import React from 'react';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../components/layout/DefaultBusinessLayout';
import EducationSeries from './home/async';
import EducationSeriesDetail from './detail/async';

export default [
  <Route
    key="/business/education-series/detail/:sessionId?"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Education Series',
            item: '/business/education-series/detail',
          },
        ]}
      />
    }
  >
    <Route
      path="business/education-series/detail/:sessionId?"
      element={<EducationSeriesDetail />}
    />
  </Route>,
  <Route
    key="/business/education-series"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Education Series',
            item: '/business/education-series',
          },
        ]}
      />
    }
  >
    <Route
      path="business/education-series"
      element={<EducationSeries />}
    />
  </Route>,
];
